import React from 'react';
import ReactDOM from 'react-dom';
import { App } from '@root/src/web/components/App';
export const HydrateApp = ({ CAPI, NAV }) => {
    ReactDOM.render(React.createElement(App, { CAPI: CAPI, NAV: NAV }), document.getElementById('react-root'));
};
